<template>
  <div class="page-wrapper">
    <header class="main-header">
      <nav class="main-menu">
        <div class="main-menu__wrapper">
          <div class="main-menu__wrapper-inner">
            <div class="main-menu__logo">
              <a href="/"><img src="img/logo.png" alt="FHIS" style="width: 150px; height: 100px" /></a>
            </div>
            <div class="main-menu__top">
              <div class="main-menu__top-inner">
                <div class="main-menu__top-left">
                  <div class="main-menu__social">
                    <a href="https://x.com/AbujaFhis?t=oUd8AVkdttwjDRKKxHVebQ&s=08" target="_blank"><i
                        class="fab fa-twitter"></i></a>
                    <a href="https://www.facebook.com/share/1BHSex47fK/" target="_blank"><i
                        class="fab fa-facebook"></i></a>
                    <!-- <a href="#"><i class="fab fa-pinterest-p"></i></a> -->
                    <a href="https://www.instagram.com/fhisabuja?igsh=cXUyeHRtd3ZldHNk" target="_blank"><i
                        class="fab fa-instagram"></i></a>
                    <a href="https://youtube.com/@fcthealthinsuranceschemefh9664?si=Bq4-86_6pjbPK_5e" target="_blank"><i
                        class="fab fa-youtube"></i></a>
                  </div>
                </div>
                <div class="main-menu__top-right">
                  <ul class="list-unstyled main-menu__contact-list">
                    <li>
                      <div class="icon">
                        <i class="fas fa-envelope"></i>
                      </div>
                      <div class="text">
                        <p>
                          <a href="mailto:info@fhis.abj.gov.ng">info@fhis.abj.gov.ng</a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div class="icon">
                        <i class="fas fa-ticket"></i>
                      </div>
                      <div class="text">
                        <a class="about-one__btn thm-btn" href="https://portal.fhis.abj.gov.ng/help"
                          target="_blank">
                          FHIS Self-Service
                        </a>
                      </div>
                    </li>
                  </ul>
                  <!-- <ul class="list-unstyled main-menu__top-menu">
                    <li><a href="about">Council</a></li>
                    <li><a href="about">Government</a></li>
                    <li><a href="team">Complaints</a></li>
                  </ul> -->
                </div>
              </div>
            </div>
            <div class="main-menu__bottom">
              <div class="main-menu__bottom-inner">
                <div class="main-menu__main-menu-box">
                  <a href="#" class="mobile-nav__toggler"><i class="fa fa-bars"></i></a>
                  <ul class="main-menu__list">
                    <li class="dropdown megamenu">
                      <a href="/">Home </a>
                    </li>

                    <li>
                      <a href="/about">About Us</a>
                    </li>

                    <li>
                      <a href="/contact">Contact</a>
                    </li>

                    <li class="dropdown">
                      <a href="/programs">Programs</a>
                    </li>

                    <li>
                      <a href="/team">Team</a>
                    </li>

                    <li>
                      <a href="#">Benefit Package</a>
                    </li>

                    <li class="dropdown">
                      <a href="#">TPAs</a>
                      <ul class="sub-menu">
                        <li><a href="#">Providers</a></li>
                        <li><a href="#">HMOs </a></li>
                      </ul>
                    </li>

                    <!-- <li class="dropdown">
                      <a href="#">Documents</a>
                      <ul class="sub-menu">
                        <li><a href="#">Benefit Package</a></li>
                        <li><a href="#">Operation Guidelines </a></li>
                      </ul>
                    </li> -->
                  </ul>
                </div>
                <!-- <div class="main-menu__right">
                  <div class="main-menu__btn-box">
                    <a
                      href="https://portal.fhis.abj.gov.ng/self-enrollment/930972/2648"
                      target="_blank"
                      class="thm-btn main-menu__btn"
                      >Register Now</a
                    >
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <!-- AI Chat -->
    <div>
      <VueBotUI :messages="messages" :options="botOptions" @msg-send="messageSendHandler" :bot-typing="isBotTyping" />
    </div>
    <!--End of AI Chat -->

    <div class="stricky-header stricked-menu main-menu">
      <div class="sticky-header__content"></div>
      <!-- /.sticky-header__content -->
    </div>
    <!-- /.stricky-header -->
    <router-view />

    <!--Site Footer Start-->
    <footer class="site-footer">
      <div class="site-footer__img">
        <img src="image/fhis/activity-7.jpg" alt="" />
      </div>
      <div class="container">
        <div class="site-footer__top">
          <div class="footer-widget__logo">
            <a href="index.html"><img src="img/logo.png" alt="" /></a>
          </div>
          <div class="footer-widget__subscribe-box">
            <div class="footer-widget__subscribe-text">
              <p>Subscribe to Newsletter</p>
            </div>
            <form class="footer-widget__email-box mc-form" data-url="#">
              <div class="footer-widget__email-input-box">
                <input type="email" placeholder="Email Address" name="EMAIL" />
              </div>
              <button type="submit" class="footer-widget__subscribe-btn thm-btn">
                Subscribe
              </button>
            </form>
            <div class="mc-form__response"></div>
            <!-- /.mc-form__response -->
          </div>
        </div>
        <div class="site-footer__middle">
          <div class="row">
            <div class="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="100ms">
              <div class="footer-widget__column footer-widget__Contact">
                <div class="footer-widget__title-box">
                  <h3 class="footer-widget__title">Contact</h3>
                </div>
                <p class="footer-widget__Contact-text">
                  Head Office - No.5 Portharcourt Crescent, Off Gimbiya Street,
                  Opp. Residency Hotel, Area 11, Garki, Abuja.<br />
                  <br />
                </p>
                <ul class="footer-widget__Contact-list list-unstyled">
                  <li>
                    <div class="icon">
                      <span class="icon-email"></span>
                    </div>
                    <div class="text">
                      <p>
                        <a href="mailto:info@fhis.abj.gov.ng">info@fhis.abj.gov.ng</a>
                      </p>
                    </div>
                  </li>
                  <li>
                    <div class="icon">
                      <span class="fas fa-phone-square"></span>
                    </div>
                    <div class="text">
                      <p>
                        <a href="tel:+2347042244000">+234 704 224 4000, </a>
                        <a href="tel:+2349099989906">+2349099989906, </a>
                        <a href="tel:+2349099989905">+2349099989905</a>
                      </p>
                    </div>
                  </li>
                </ul>
                <div class="site-footer__social">
                  <a href="https://x.com/AbujaFhis?t=oUd8AVkdttwjDRKKxHVebQ&s=08" target="_blank"><i
                      class="fab fa-twitter"></i></a>
                  <a href="https://www.facebook.com/share/1BHSex47fK/" target="_blank"><i
                      class="fab fa-facebook"></i></a>
                  <!-- <a href="#"><i class="fab fa-pinterest-p"></i></a> -->
                  <a href="https://www.instagram.com/fhisabuja?igsh=cXUyeHRtd3ZldHNk" target="_blank"><i
                      class="fab fa-instagram"></i></a>
                  <a href="https://youtube.com/@fcthealthinsuranceschemefh9664?si=Bq4-86_6pjbPK_5e" target="_blank"><i
                      class="fab fa-youtube"></i></a>
                </div>
              </div>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-6 wow fadeInUp" data-wow-delay="200ms">
              <div class="footer-widget__column footer-widget__link">
                <div class="footer-widget__title-box">
                  <h3 class="footer-widget__title">Links</h3>
                </div>
                <ul class="footer-widget__link-list list-unstyled">
                  <li><a href="about">About</a></li>
                  <li><a href="team">Our Team</a></li>
                  <!-- <li><a href="news.html">Latest News</a></li> -->
                  <li><a href="team">Contact</a></li>
                  <li><a href="https://portal.fhis.abj.gov.ng/add-complaint/930972">Submit a Complaint</a></li>

                </ul>
              </div>
            </div>
            <!-- <div
              class="col-xl-2 col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay="300ms"
            >
              <div class="footer-widget__column footer-widget__departments">
                <div class="footer-widget__title-box">
                  <h3 class="footer-widget__title">Departments</h3>
                </div>
                <ul class="footer-widget__link-list list-unstyled">
                  <li><a href="about">Health & Safety</a></li>
                  <li><a href="about">Housing & Land</a></li>
                  <li><a href="about">Legal & Finance</a></li>
                  <li><a href="about">Transport & Traffic</a></li>
                  <li><a href="about">Arts & Culture</a></li>
                </ul>
              </div>
            </div>-->
            <!-- <div
              class="col-xl-2 col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay="400ms"
            >
              <div class="footer-widget__column footer-widget__explore">
                <div class="footer-widget__title-box">
                  <h3 class="footer-widget__title">Explore</h3>
                </div>
                <ul class="footer-widget__link-list list-unstyled">
                  <li><a href="about">Administration</a></li>
                  <li><a href="about">Fire Services</a></li>
                  <li><a href="tax-return.html">Business & Taxation</a></li>
                  <li><a href="about">Circular’s And Go’s</a></li>
                </ul>
              </div>
            </div> -->
            <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="500ms">
              <!-- <div class="footer-widget__column footer-widget__gallery">
                <div class="footer-widget__title-box">
                  <h3 class="footer-widget__title">Gallery</h3>
                </div>
                <ul class="footer-widget__gallery-list list-unstyled clearfix">
                  <li>
                    <div class="footer-widget__gallery-img">
                      <img
                        src="assets/images/gallery/footer-widget-gallery-img-1.jpg"
                        alt=""
                      />
                      <a
                        href="assets/images/gallery/footer-widget-gallery-img-1.jpg"
                        class="img-popup"
                        ><span class="fab fa-instagram"></span
                      ></a>
                    </div>
                  </li>
                  <li>
                    <div class="footer-widget__gallery-img">
                      <img
                        src="assets/images/gallery/footer-widget-gallery-img-2.jpg"
                        alt=""
                      />
                      <a
                        href="assets/images/gallery/footer-widget-gallery-img-2.jpg"
                        class="img-popup"
                        ><span class="fab fa-instagram"></span
                      ></a>
                    </div>
                  </li>
                  <li>
                    <div class="footer-widget__gallery-img">
                      <img
                        src="assets/images/gallery/footer-widget-gallery-img-3.jpg"
                        alt=""
                      />
                      <a
                        href="assets/images/gallery/footer-widget-gallery-img-3.jpg"
                        class="img-popup"
                        ><span class="fab fa-instagram"></span
                      ></a>
                    </div>
                  </li>
                  <li>
                    <div class="footer-widget__gallery-img">
                      <img
                        src="assets/images/gallery/footer-widget-gallery-img-4.jpg"
                        alt=""
                      />
                      <a
                        href="assets/images/gallery/footer-widget-gallery-img-4.jpg"
                        class="img-popup"
                        ><span class="fab fa-instagram"></span
                      ></a>
                    </div>
                  </li>
                  <li>
                    <div class="footer-widget__gallery-img">
                      <img
                        src="assets/images/gallery/footer-widget-gallery-img-5.jpg"
                        alt=""
                      />
                      <a
                        href="assets/images/gallery/footer-widget-gallery-img-5.jpg"
                        class="img-popup"
                        ><span class="fab fa-instagram"></span
                      ></a>
                    </div>
                  </li>
                  <li>
                    <div class="footer-widget__gallery-img">
                      <img
                        src="assets/images/gallery/footer-widget-gallery-img-6.jpg"
                        alt=""
                      />
                      <a
                        href="assets/images/gallery/footer-widget-gallery-img-6.jpg"
                        class="img-popup"
                        ><span class="fab fa-instagram"></span
                      ></a>
                    </div>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="site-footer__bottom">
        <div class="container">
          <div class="row">
            <div class="col-xl-12">
              <div class="site-footer__bottom-inner">
                <p class="site-footer__bottom-text">
                  &copy; <a href="#">FHIS All Rights Reserved</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--Site Footer End-->
  </div>
</template>
<script>
  import { VueBotUI } from "@/vue-bot-ui.umd.min.js";
  import BotIcon from "./assets/bot.png";
  export default {
    components: {
      VueBotUI,
    },
    data() {
      return {
        isBotTyping: false,
        messages: [
          {
            agent: "bot",
            type: "text",
            text: "Hello! How can I assist you today?",
            disableInput: false,
          },
        ],
        botOptions: {
          botTitle: "FHIS ChatBot",
          botAvatarImg: BotIcon,
          colorScheme: "#00ff00",
          textColor: "#000",
          boardContentBg: "#fff",
          msgBubbleBgBot: "#f0f0f0",
          msgBubbleBgUser: "#0f0",
          inputPlaceholder: "Say Something",
          // other customization options
        },
      };
    },
    methods: {
      async messageSendHandler(message) {
        // Add the user's message to the messages array
        const url = "https://api-aichat.hayokmedicare.ng/ABJ_FAQ"; // Replace with your API endpoint
        const data = {
          user_id: "user",
          prompt: message.text,
        };
        this.messages.push({
          agent: "user",
          type: "text",
          text: message.text,
        }); //User message that will appear on the chatbox
        this.isBotTyping = true; //bot typing status

        try {
          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
            },
            body: JSON.stringify(data),
          });

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          const jsonResponse = await response.json();
          this.isBotTyping = false; //bot typing status
          this.messages.push({
            agent: "bot",
            type: "text",
            text: jsonResponse.response,
          }); //Bot response from API call
        } catch (error) {
          this.responseMessage = `Error: ${error.message}`;
        }
      },
    },
  };
</script>


<style>
  div.qkb-board-header__title,
  div.qkb-msg-bubble-component__text,
  input.qkb-board-action__input {
    font-size: 1.875rem;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;
  }

  nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  nav a.router-link-exact-active {
    color: #42b983;
  }
</style>